// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { FunctionComponent } from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";

import { EditableProps } from "components/Editor/EditablePropsType";
import { getDefaultQuestionDefinition } from "./Questionnaire/QuestionnaireUtils";

interface TitleProps extends TypographyProps {
  content?: string;
}

export const TitleEditableProps: EditableProps = {
  content: {
    ...getDefaultQuestionDefinition(),
    name: "content",
    label: "content",
    valueType: "string",
    mandatory: true,
  },
};

const Title: FunctionComponent<TitleProps> = (props: TitleProps) => {
  const { content, children, ...rest } = props;
  if (!content && !children) {
    return null;
  }
  return (
    <Typography variant="h1" {...rest}>
      {content}
      {children}
    </Typography>
  );
};

export default Title;
